module.exports = __webpack_public_path__ + "img/tc-15.36fdbff3.png";